import Sample from './src/Sample';

export default Sample;
